import {Grid} from "@mui/system";
import {MenuItem, TextField, Typography} from "@mui/material";
import {useEffect, useState} from "react";


export const useTallaDesplegable = ({variaciones = []}) => {
    const [seleccionada, setSeleccionada] = useState(
        {}
    )
    const [valor, setValor] = useState('')

    const obtenerNombre = (nombre) => {

        const maxLetra = 20
        if (!nombre) {
            return ''
        }

        if (nombre.length > maxLetra) {
            return nombre.substring(0, maxLetra) + '...'
        } else {
            return nombre
        }
    }

    const obtenerPrimeraDisponible = (arr) => {

        for (let i = 0; i < arr.length; i++) {
            let item = arr[i]
            if (item.cantidad && parseInt(item.cantidad) > 0) {
                return item
            }
        }

        return arr[0]
    }

    useEffect(() => {

        if (variaciones && variaciones.length > 0) {
            let prim = obtenerPrimeraDisponible(variaciones)
            setSeleccionada(prim)
            setValor(prim.nombre)
        }

    }, [variaciones]);
    const Tallas = () => {

        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



            </Grid>
        )


    }

    return {
        Tallas,
        seleccionada
    }

}

